<template>
  <div>
    <h1 class="page-header">
      {{
        $t(
          'administration.employee.employeeDailyTimescan.employeeDailyTimescan'
        )
      }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="ts-flex">
            <div class="ts-flex">
              <label class="col-sm-4 control-label">
                {{
                  $t('administration.employee.employeeDailyTimescan.dateFrom')
                }}</label
              >
              <div>
                <ts-date-picker-input
                  v-model="date_from"
                ></ts-date-picker-input>
              </div>
            </div>
            <div class="ts-flex">
              <label class="col-sm-4 control-label">
                {{
                  $t('administration.employee.employeeDailyTimescan.dateTo')
                }}</label
              >
              <div>
                <ts-date-picker-input v-model="date_to"></ts-date-picker-input>
              </div>
            </div>
            <div class="ts-flex">
              <label class="ts-w-24 control-label">
                {{
                  $t('administration.employee.employeeDailyTimescan.department')
                }}</label
              >
              <div class="ts-w-32 ts-mr-4">
                <a-select
                  v-model="model.department_id"
                  :options="departments"
                  @change="departmentOptions"
                  class="ts-ml-3"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                ></a-select>
              </div>
            </div>
            <div class="ts-ml-3 ts-w-24">
              <ts-button
                class="btn-block"
                outline
                color="success"
                :waiting="exporting"
                @click.prevent="exportExcel"
                >{{ $t('excel') }}</ts-button
              >
            </div>
            <div class="ts-flex-grow"></div>
            <div class="ts-flex ts-h-8">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 300px"
              />
              <ts-button
                outline
                class="ml-2"
                v-tooltip="$t('filter')"
                @click.prevent="visible = true"
              >
                <i class="fa fa-filter"></i>
              </ts-button>
            </div>
            <a-drawer
              :title="$t('invoice.filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="() => (visible = false)"
              :zIndex="1020"
              width="300px"
            >
              <div style="font-size: 12px">
                <div class="row">
                  <div class="form-group">
                    <label class="control-label">
                      {{
                        $t(
                          'administration.employee.employeeDailyTimescan.branch'
                        )
                      }}</label
                    >
                    <a-select
                      v-model="branch_id"
                      :options="branches"
                      @change="branchOptions"
                      style="width: 250px"
                      showSearch
                      mode="multiple"
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      :maxTagCount="1"
                    ></a-select>
                  </div>
                  <div class="form-group">
                    <label class="control-label">
                      {{
                        $t(
                          'administration.employee.employeeDailyTimescan.department'
                        )
                      }}</label
                    >
                    <div>
                      <a-select
                        v-model="model.department_id"
                        :options="departments"
                        @change="departmentOptions"
                        style="width: 250px"
                        showSearch
                        mode="multiple"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :maxTagCount="1"
                      ></a-select>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">
                      {{
                        $t(
                          'administration.employee.employeeDailyTimescan.employeeName'
                        )
                      }}</label
                    >
                    <div>
                      <a-select
                        v-model="model.staff_id"
                        :options="employees"
                        @change="employeeOptions"
                        style="width: 250px"
                        showSearch
                        mode="multiple"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :maxTagCount="1"
                      ></a-select>
                    </div>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </form>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <a-tabs v-model:activeKey="model.type" @change="onTypeChange">
          <a-tab-pane key="detail">
            <template #tab>
              <span> Detail </span>
            </template>
            <ts-loading-banner :loading="loading">
              <detail @fetch="onTypeChange"></detail>
            </ts-loading-banner>
          </a-tab-pane>
          <a-tab-pane key="attendance">
            <template #tab>
              <span> Attendance with Status </span>
            </template>
            <ts-loading-banner :loading="loading">
              <attendance-with-status
                ref="attendance"
                v-model="model"
                :validate="errors"
              ></attendance-with-status>
            </ts-loading-banner>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="onTypeChange"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce, trim } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import Detail from './components/detail.vue'
import AttendanceWithStatus from './components/attendance-with-status.vue'

export default {
  name: 'employee-daily-timescan',
  components: { Detail, AttendanceWithStatus },
  data () {
    return {
      visible: false,
      errors: new Errors(),
      loading: false,
      exporting: false,
      departments: [],
      employees: [],
      branches: [],
      branch_id: [],
      model: {
        department_id: [],
        staff_id: [],
        type: 'detail'
      }
    }
  },
  created () {
    this.fetchData()
    this.getDepartment()
    this.getBranch()
    this.getEmployee()
  },
  computed: {
    ...mapState('employeeDailyTimescan', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.employeeDailyTimescan.search
      },
      set (newValue) {
        this.$store.commit('employeeDailyTimescan/SET_SEARCH', newValue)
        this.$store.commit('employeeDailyTimescan/RESET_CURRENT_PAGE')
      }
    },
    date_from: {
      get () {
        return this.$store.state.employeeDailyTimescan.date_from
      },
      set (val) {
        this.$store.commit('employeeDailyTimescan/SET_DATE_FROM', val)
      }
    },
    date_to: {
      get () {
        return this.$store.state.employeeDailyTimescan.date_to
      },
      set (val) {
        this.$store.commit('employeeDailyTimescan/SET_DATE_TO', val)
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'employeeDailyTimescan/fetch',
          Object.assign(
            {},
            this.model,
            {
              branch_id: this.branch_id,
              department_id: this.model.department_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    fetchDataAttendance (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'employeeDailyTimescan/fetchAttendance',
          Object.assign(
            {},
            this.model,
            {
              branch_id: this.branch_id,
              department_id: this.model.department_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    onTypeChange (attributes) {
      if (this.model.type == 'detail') {
        this.fetchData(attributes)
      } else {
        this.fetchDataAttendance(attributes)
      }
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'employeeDailyTimescan/exportExcel',
          Object.assign({}, this.model, {
            branch_id: this.branch_id,
            department_id: this.model.department_id
          })
        )
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    departmentOptions (value) {
      this.$store.commit('employeeDailyTimescan/SET_DEPARTMENT_ID', value)
      if (this.model.type == 'detail') {
        this.fetchData()
      } else {
        this.fetchDataAttendance()
      }
    },
    getDepartment () {
      this.$store
        .dispatch('employeeDailyTimescan/getDepartment')
        .then(response => {
          this.departments = response.data.map(el => ({
            value: el.department_id,
            label: el.department_name_en
          }))
        })
    },
    employeeOptions (value) {
      this.$store.commit('employeeDailyTimescan/SET_EMPLOYEE_ID', value)
      if (this.model.type == 'detail') {
        this.fetchData()
      } else {
        this.fetchDataAttendance()
      }
    },
    getEmployee () {
      this.$store
        .dispatch('employeeDailyTimescan/getEmployee')
        .then(response => {
          this.employees = response.data.map(el => ({
            value: el.staff_id,
            label: el.name_en + '|' + el.name_kh
          }))
        })
    },
    branchOptions (value) {
      this.$store.commit('employeeDailyTimescan/SET_BRANCH_ID', value)
      if (this.model.type == 'detail') {
        this.fetchData()
      } else {
        this.fetchDataAttendance()
      }
    },
    getBranch () {
      this.$store.dispatch('employeeDailyTimescan/getBranch').then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      if (this.model.type == 'detail') {
        this.fetchData({ search })
      } else {
        this.fetchDataAttendance({ search })
      }
    }, 500),
    date_from: function () {
      if (this.model.type == 'detail') {
        this.fetchData()
      } else {
        this.fetchDataAttendance()
      }
    },
    date_to: function () {
      if (this.model.type == 'detail') {
        this.fetchData()
      } else {
        this.fetchDataAttendance()
      }
    },
    department_id: debounce(function () {
      this.fetchData()
    }, 500),
    branch_id: debounce(function (value) {
      if (this.model.type == 'detail') {
        this.fetchData({ branch_id: value })
      } else {
        this.fetchDataAttendance({ branch_id: value })
      }
    }, 500),
    staff_id: debounce(function (value) {
      this.fetchData({ staff_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('employeeDailyTimescan/RESET_STATE')
    next()
  }
}
</script>
<style lang="scss" scoped>
.table > thead > tr > th {
  border: 1px solid #b6c2c9;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: transparent;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}

div::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}
</style>
